<template>
  <router-view />
</template>

<script>
export default {
  name: "ServiceQuestionSingle"
};
</script>